import item1 from '../assets/solutions/item1.svg';
import item2 from '../assets/solutions/item2.svg';
import item3 from '../assets/solutions/item3.svg';
import item4 from '../assets/solutions/item4.svg';
import item5 from '../assets/solutions/item5.svg';
import item6 from '../assets/solutions/item6.svg';

import { getContent } from '../store/ContentStore';

const ICON_MAP = {
    item1: item1,
    item2: item2,
    item3: item3,
    item4: item4,
    item5: item5,
    item6: item6,
};

const MAX_SOLUTIONS_ITEMS = Object.keys(ICON_MAP).length; 

export const loadSolutionsContentEn = () => {
    const solutionsData = getContent("solutions.", "en");

    if (!solutionsData || !solutionsData.en || Object.keys(solutionsData.en).length === 0) {
        return { title: '', solutions: [] };
    }
    
    const englishLabels = solutionsData.en; 
   
    const mainTitle = englishLabels['solutions.title'] || 'Default Solutions Title';

    const solutionsArray = [];

    for (let i = 1; i <= MAX_SOLUTIONS_ITEMS; i++) {
        const itemKey = `item${i}`; 
        
        const headingKey = `solutions.${itemKey}.title`;
        const descriptionKey = `solutions.${itemKey}.description`;
        
        const heading = englishLabels[headingKey];
        const description = englishLabels[descriptionKey];
        const icon = ICON_MAP[itemKey]; 

        if (heading && description && icon) {
            solutionsArray.push({
                icon: icon,
                heading: heading,
                description: description,
            });
        }
    }
    
    return {
        title: mainTitle,
        solutions: solutionsArray,
    };
};


export const loadSolutionsContentRo = () => {
    const solutionsData = getContent("solutions.", "ro");

    if (!solutionsData || !solutionsData.ro || Object.keys(solutionsData.ro).length === 0) {
        return { title: '', solutions: [] };
    }
    
    const romanianLabels = solutionsData.ro; 
   
    const mainTitle = romanianLabels['solutions.title'] || 'Default Solutions Title';

    const solutionsArray = [];

    for (let i = 1; i <= MAX_SOLUTIONS_ITEMS; i++) {
        const itemKey = `item${i}`; 
        
        const headingKey = `solutions.${itemKey}.title`;
        const descriptionKey = `solutions.${itemKey}.description`;
        
        const heading = romanianLabels[headingKey];
        const description = romanianLabels[descriptionKey];
        const icon = ICON_MAP[itemKey]; 

        if (heading && description && icon) {
            solutionsArray.push({
                icon: icon,
                heading: heading,
                description: description,
            });
        }
    }
    
    return {
        title: mainTitle,
        solutions: solutionsArray,
    };
};